import { createAction, props } from '@ngrx/store'
import { IUser } from './auth.state'

export const setUser = createAction('[AUTH] Set User', props<{ user: IUser }>())
export const removeUser = createAction('[AUTH] Remove User')
